import DealerApplicantForm from './DealerApplicantForm';

export default DealerApplicantForm;
